import { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import { createReduxStore } from '@/shared/config/storeConfig/store';
import { StateSchema } from '@/shared/types/store';
import { setStore } from '@/shared/lib/store/storeInstance';

interface StoreProviderProps extends PropsWithChildren {
  initialState?: StateSchema;
}

export const StoreProvider = ({ children, initialState }: StoreProviderProps) => {
  const store = createReduxStore(initialState);
  setStore(store);

  return <Provider store={store}>{children}</Provider>;
};
